import React from "react";
import "./Values.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";


class Values extends React.Component {
    render() {
        return (
            <div>
                <Nav/>
                <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/About">01 About Us</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Skills"> 02 Governance Structure</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Partners">03 Partners & Potential Investors</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Values"> 04 Our Core Values</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
            </div>
          </div>
        <div className="col-8">
        <div class="abhead10">
        <p></p>
        </div>
        <div class="jumbotron">
          <h3 style={{margin: 0, fontWeight: 'bold'}}>OUR VALUES/PHILOSOPHY</h3>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}>Keeping you abreast with technology, tools, new developments and giving you the best technical support services in the green built-environment</p>
        <p className="text-justify">These are values that are inspiring all of our decisions – these are our core values; our guiding principles.
From one decision to another, founder to co-founder, employee to employee, day to day, Good Morning Bamboo’s entire company works by a set of core “Values,” designed to assure that every aspect of our business is managed and conducted with the best interest of the environment, customers, employees, profit and all of our partners and stakeholders in mind. These Core Values are: Respect, Customer Focus, Long-Term Sustainability, Efficiency, Responsibility, and Excellence.</p>

<p style={{margin: 0, fontWeight: 'bold', marginTop: '5%'}}>RESPECT:</p>
            <ul>
                <li>•	Respect of commitments/handshake/deadlines/schedules</li>
                <li>•	Respect of others, their ideas, their differences, their cultures. Respect of laws, rules, procedures, conventions, and contracts</li>
                <li>•	Respect of environment, nature, neighbourhood</li>
            </ul>
            <p style={{margin: 0, fontWeight: 'bold', marginTop: '5%'}}>CUSTOMER FOCUS: </p>
            <ul>
                <li>•	Deliver the right quality in terms of products, services and any deliverables</li>
                <li>•	Deliver the right quality in terms of products, services and any deliverables</li>
                <li>•	Make our customer’s life easier by improving on our mandate</li>
            </ul>
            <p style={{margin: 0, fontWeight: 'bold', marginTop: '5%'}}>LONG TERM:</p>
            <ul>
                <li>•	Win the loyalty of our paying clients/customers. Warranty them with long term supply in quality & quantity.</li>
                <li>•	Build up a solid and efficient organization based on Carbon neutral or negative emissions simple and natural technologies</li>
                <li>•	Invest in order to last, invest for the future</li>
            </ul>
            <p style={{margin: 0, fontWeight: 'bold', marginTop: '5%'}}>EFFICIENCY:</p>
            <ul>
                <li>•	Make it simple rather than complicated</li>
                <li>•	Produce the maximum of added value with minimal/appropriates resources</li>
                <li>•	Spend wisely</li>
            </ul>
            <p style={{margin: 0, fontWeight: 'bold', marginTop: '5%'}}>RESPONSIBILITY:</p>
            <ul>
                <li>•	Address problems and resolve them using the latest environmentally friendly technologies</li>
                <li>•	Dare to make decisions, have the I-can-do-mentality and dare to know that anything is possible and don’t forget that you are your limit</li>
                <li>•	Nothing we do is worth getting injured for, think safety – safety first, because your health is paramount</li>
            </ul>
            <p style={{margin: 0, fontWeight: 'bold', marginTop: '5%'}}>Profitability</p>
            <ul>
                <li>•	Bear in mind the in every labour, there must be profit</li>
            </ul>
            <p style={{margin: 0, fontWeight: 'bold', marginTop: '5%'}}>Excellence</p>
            <ul>
                <li>•	Have an excellent spirit and practice excellence – do more than is expected of you, always exceed people’s expectation of you.</li>
            </ul>
            <h3 className="mt-5">CODE OF ETHICS</h3>
            <p>We embrace our responsibilities and committed to executing them to the letter and the spirit; <span style={{fontWeight: 'bold'}}>INDIVIDUALLY and COLLECTIVELY</span>. We make meaningful commitments first to each other and then to those with whom we work live and serve.<br/><br/>
            <span style={{fontWeight: 'bold'}}>Responsibility to Improve our work environment and the environment in which we live</span><br/>
            Good Morning Bamboo constantly strives to find new ways of improving the health & safety of its employees.
            <br/><br/><span style={{fontWeight: 'bold'}}>Acting as a cleantech partner and employer</span><br/>
        Our employees are our most valuable assets and we care about their development. Good Morning Bamboo is always committed to give back to nature with interest what has been borrowed. We are looking for the best available technologies to maximize the efficiency or resources usage, while minimizing or eliminating waste based on permaculture principles.
        <br/><br/><span style={{fontWeight: 'bold'}}>Respect for Human Rights, equality of employment and diversity</span>
Good Morning Bamboo is committed to the principle of treating each stakeholder with respect and dignity according to the local/international laws and regulations where we do business.
<br/><br/><span style={{fontWeight: 'bold'}}>Integrity in our business decisions/ Conduct our business with integrity</span>
All our decisions are driven by our five strong values: respect, customer focus, long term, efficiency, responsibility


        </p>
        </div>
        </div>
 </div>
            </div>
        )
    }
}
export default withRouter(Values);